// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__30NDF","content":"GlobalSearch_content__1esap"};